import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import GELiveBlog from "@components/Layouts/GeneralElection/GELiveBlog";
import Divider from "@elements/Divider/Divider";
import Heading from "@elements/Typography/Heading";
import { isArrayWithElements } from "@helper/utils";
import { FeatureHomeWidgetProps } from "@typings/PagePayloadType";
import { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type liveBlogStyleProps = {
  wrapperStyle?: string;
};

export default function TNEHomeWidget({
  liveBlog,
  topStories,
}: FeatureHomeWidgetProps): ReactElement {
  const title = "சட்டமன்றத் தேர்தல் 2026";
  const electionUrl = "/keywords/state-election-2026?ref=tlf-home";
  const electionLinkProps = {
    reloadDocument: true,
    to: electionUrl,
    target: "_blank",
    rel: "noopener noreferrer",
  } as const;

  const styles: liveBlogStyleProps = {
    wrapperStyle: "min-h-[350px] xl:w-[600px]",
  };

  const articleStyle = `w-full ${liveBlog ? "lg:w-full" : "lg:w-1/2"} xl:w-1/2 order-last`;

  return (
    <div className="flex flex-col gap-xs bg-gray-500 mb-5 xl:mx-[-95px] xl:px-0 xl:w-[100%+190px]">
      <div className="w-full h-2.5 bg-gradient-to-r from-pink-701 to-pink-301 xl:mb-5"></div>
      <div className="xl:max-w-xl w-full mx-auto xxs:px-sm xl:p-0 max-xsm:px-1 mb-10">
        <div>
          <div className="mb-5 md:mb-2.5">
            <Heading
              Element="h1"
              className={twMerge(
                "inline font-bold font-primary text-sm lg:text-2.5md leading-9 mb-5",
              )}
            >
              <Link
                {...electionLinkProps}
                className="text-pink-200 inline md:hidden"
              >
                {title}
              </Link>
              <span className="hidden md:inline">{title}</span>
            </Heading>
            <div className="ml-2.5 md:pl-12 inline float-right mt-2 md:mt-4">
              <Link
                {...electionLinkProps}
                aria-label="சட்டமன்றத் தேர்தல் 2026 மேலும் படிக்க"
                className="text-pink-200 font-bold text-base lg:text-sm leading-6"
              >
                <span className="hidden md:inline">மேலும் படிக்க</span>
                <img
                  alt=""
                  aria-hidden="true"
                  height={28}
                  width={28}
                  className="pl-[5px] inline"
                  src={ChevronImage}
                />
              </Link>
            </div>
          </div>
          <Divider className="border-b border-gray-2200 mb-5" />
        </div>

        <div className="flex flex-wrap">
          {liveBlog && (
            <div className="w-full xl:w-1/2 lg:w-2/3 xl:pr-5 liveblog-home mb-380 xl:mb-0 order-first lg:order-second">
              <GELiveBlog
                variant="sidebar"
                geLiveBlogContent={liveBlog}
                styles={styles}
              />
            </div>
          )}
          <div className={articleStyle}>
            {isArrayWithElements(topStories) ? (
              <>
                <div className="text-sm font-medium font-secondary leading-6 pb-2.5">
                  செய்திகள்
                </div>
                {topStories.map((article, i, row) => (
                  <ArticleCard
                    displayWidth={135}
                    displayHeight={90}
                    key={article.id}
                    elements={{ hasParagraph: false, hasDate: true }}
                    overrideStyle={{
                      cardWrapper: twMerge(
                        "flex-row",
                        i + 1 === row.length
                          ? "border-b-0 pb-0"
                          : "border-b-gray-2050",
                        i === 0 && "pt-0",
                      ),
                      titleStyle:
                        "font-semibold font-primary text-2sm text-gray-100 hover:text-gray-100",
                      imageWrapperStyle: "hidden",
                      contentWrapper: "gap-xs",
                      titleWrapper: "gap-0",
                      imageStyle: "w-full h-23",
                    }}
                    refMedium="home_tne_top_stories"
                    {...article}
                  />
                ))}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
